import { memo } from 'react';
import { observer } from 'mobx-react';

import './style.scss';

const ServiceQuestion = observer(({ data }) => {
    const title = data?.title;
    const contents = data?.contents || [];

    return (
        <section className="concerns-section">
            {title && (
                <h2 className="concerns-title">
                    {title}
                    <span className="tail-title"></span>
                    <span className="down"></span>
                </h2>
            )}
            <div className="concerns-bubbles">
                <div className="row row-1">
                    {contents?.slice(0, 3)?.map((item, index) => (
                        <div key={index} className={`bubble ${item.shape}`}>
                            <div className={`text-content text-content-row1-${index}`}>
                                {index === 2 ? (
                                    <>
                                        <span className='text' style={{ whiteSpace: 'pre-line' }}>{item?.text1}</span>
                                        <span className='sub-text'>{item?.text2}</span>
                                    </>
                                ) : (
                                    <>
                                        <span className='sub-text'>{item?.text1}</span>
                                        <span className='text' style={{ whiteSpace: 'pre-line' }}>{item?.text2}</span>
                                    </>
                                )}
                            </div>

                            {item.shape === 'rect' && (
                                <>
                                    <span className="top-rect"></span>
                                    <span className="tail-rect"></span>
                                    <span className="down-rect"></span>
                                </>
                            )}
                            {item.shape === 'oval' && (
                                <>
                                    {index === 2 ? (
                                        <>
                                            <span className="tail-oval-right"></span>
                                            <span className="down-oval-right"></span>
                                        </>
                                    ) : (
                                        <>
                                            <span className="tail-oval-left"></span>
                                            <span className="down-oval-left"></span>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    ))}

                </div>

                <div className="row row-2">
                    {contents.slice(3).map((item, index) => (
                        <div key={index} className={`bubble ${item.shape}`}>
                            <div className={`text-content text-content-row2-${index}`}>
                                {index === 1 ? (
                                    <>
                                        <span className='sub-text'>{item?.text1}</span>
                                        <span className='text'>{item?.text2}</span>
                                    </>
                                ) : (
                                    <>
                                        <span className='text'>{item?.text1}</span>
                                        <span className='sub-text'>{item?.text2}</span>
                                    </>
                                )}
                            </div>
                            {item.shape === 'rect' && (
                                <>
                                    <span className="top-rect"></span>
                                    <span className="tail-rect"></span>
                                    <span className="down-rect"></span>
                                </>
                            )}
                            {item.shape === 'oval' && (
                                <>
                                    <span className="tail-oval-left"></span>
                                    <span className="down-oval-left"></span>
                                </>
                            )}
                        </div>
                    ))}
                </div>

            </div>

            <div className="down-arrow"></div>
        </section>
    );
});

export default memo(ServiceQuestion);
